/* Analytics */

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (
    path.includes("/it/") ||
    path.endsWith("/it") ||
    path.includes("/es/") ||
    path.endsWith("/es")
  ) {
    loadGoogleAdsTag();
  }

  function loadGoogleAdsTag() {
    // Load gtag.js
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-777724849";
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", "AW-777724849");
  }
});

document.addEventListener('DOMContentLoaded', function () {
    let translation = null;

    if (window.location.pathname.includes('/fr/') || window.location.pathname.endsWith('/fr')) {
        translation = "Approuvé par";
    } else if (window.location.pathname.includes('/es/') || window.location.pathname.endsWith('/es')) {
        translation = "Gozamos de la confianza de";
    } else if (window.location.pathname.includes('/it/') || window.location.pathname.endsWith('/it')) {
        translation = "Approvato da";
    }

    if (translation) {
        const style = document.createElement('style');
        style.textContent = `
            #section-id-template--23305040789849__logo_list_NiDtYr .logo-list::before {
                content: "${translation}";
            }
        `;

        document.head.appendChild(style);
    }
});


document.addEventListener('DOMContentLoaded', function () {
    let translations = null;
    let langPrefix = '';

    if (window.location.pathname.includes('/fr/')) {
        translations = {
            "G5® Haute Cosmétiques": "G5® Haute Cosmétiques",
            "G5® Bundles": "Nos packs G5®",
            "The Full G5® Collection": "Tous les produits G5®",
            "Shop All": "Voir tous les produits"
        };
        langPrefix = '/fr';
    } else if (window.location.pathname.includes('/es/')) {
        translations = {
            "G5® Haute Cosmétiques": "G5® Haute Cosmétiques",
            "G5® Bundles": "Paquetes G5®",
            "The Full G5® Collection": "Colección completa G5®",
            "Shop All": "Ver todos los productos"
        };
        langPrefix = '/es';
    } else if (window.location.pathname.includes('/it/')) {
        translations = {
            "G5® Haute Cosmétiques": "G5® Haute Cosmétiques",
            "G5® Bundles": "Pacchetti G5®",
            "The Full G5® Collection": "Tutta la collezione G5®",
            "Shop All": "Vedi tutti i prodotti"
        };
        langPrefix = '/it';
    }

    if (translations) {
        const menuItems = document.querySelectorAll('.custom-menu a');

        menuItems.forEach((menuItem) => {
            const originalText = menuItem.textContent.trim();
            if (translations[originalText]) {
                menuItem.textContent = translations[originalText];
            }

            const originalHref = menuItem.getAttribute('href');
            if (originalHref.startsWith('/collections')) {
                menuItem.setAttribute('href', `${langPrefix}${originalHref}`);
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    let translations = null;

    if (window.location.pathname.includes('/fr/')) {
        translations = {
            "Increase in Skin Brightness": "Ont trouvé leur peau plus lumineuse",
            "Improvement in Skin Firmness": "Ont trouvé leur peau plus ferme",
            "Overall Improvement in Skin": "D'amélioration globale de la peau",
            "Enhancement in Skin Smoothness": "Ont trouvé leur peau plus douce",
            "Increase in Skin Suppleness": "Ont trouvé leur peau plus souple",
            "Reduces Blemish Appearance": "Ont trouvé une réduction des imperfections",
            "Increase in Skin Hydration Levels": "Ont trouvé leur peau mieux hydratée",
            "Improvement in Pore Visibility": "Ont trouvé leurs pores moins visibles"
        };
    } else if (window.location.pathname.includes('/es/')) {
        translations = {
            "Increase in Skin Brightness": "Aumento del brillo de la piel",
            "Improvement in Skin Firmness": "Mejora de la firmeza de la piel",
            "Overall Improvement in Skin": "Mejora general de la piel",
            "Enhancement in Skin Smoothness": "Mejora de la suavidad de la piel",
            "Increase in Skin Suppleness": "Piel más tersa",
            "Reduces Blemish Appearance": "Reducción de la aparición de manchas",
            "Increase in Skin Hydration Levels": "Mejora de la hidratación de la piel",
            "Improvement in Pore Visibility": "Difumina la visibilidad de los poros"
        };
    } else if (window.location.pathname.includes('/it/')) {
        translations = {
            "Increase in Skin Brightness": "Pelle più luminosa",
            "Improvement in Skin Firmness": "Pelle più compatta",
            "Overall Improvement in Skin": "Miglioramento generale della pelle",
            "Enhancement in Skin Smoothness": "Pelle più liscia",
            "Increase in Skin Suppleness": "Pelle più elastica",
            "Reduces Blemish Appearance": "Riduzione delle imperfezioni",
            "Increase in Skin Hydration Levels": "Pelle più idratata",
            "Improvement in Pore Visibility": "Porosità meno visibile"
        };
    }

    if (translations) {
        const boxes = document.querySelectorAll('.box-container-custom .box p');

        boxes.forEach((box) => {
            const originalText = box.textContent.trim();
            if (translations[originalText]) {
                box.textContent = translations[originalText];
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".image-page-button")) {
      document.querySelectorAll(".image-label-wrap > div").forEach((sliderEl) => {
        const flkty = Flickity.data(sliderEl);

        sliderEl.querySelectorAll(".product-block__image").forEach((img) => {
          if (img.style.display === "none") {
            img.remove();
          }
        });

        if (flkty) {
          flkty.reloadCells();
          flkty.resize();
        }
      });
    }
  });
});



document.addEventListener('DOMContentLoaded', function () {
    let translations = null;

    if (window.location.pathname.includes('/fr/')) {
        translations = {
            "Earn Extra Points": "Gagnez des points supplémentaires",
            "Here’s how you can start earning points, once you reach 500 points, you’ll get €5 off.": "Voici comment vous pouvez commencer à gagner des points, une fois que vous atteignez 500 points, vous obtiendrez 5 € de réduction.",
            "Create a Loyalty Rewards account": "Inscrivez-vous à notre programme fidélité",
            "For every €1 you spend, you earn": "Commandez en ligne",
            "Refer your friends": "Parrainez vos amis",
            "Follow us on Facebook": "Suivez-nous sur Facebook",
            "Follow us on Instagram": "Suivez-nous sur Instagram",
            "Signing up to our mailing list": "Inscription à notre newsletter",
            "Leaving a review": "Laissez un avis",
            "Double point promotions": "Promotions 'points doubles'",
            "pts": "pts"
        };
    } else if (window.location.pathname.includes('/es/')) {
        translations = {
            "Earn Extra Points": "Gana puntos extra",
            "Here’s how you can start earning points, once you reach 500 points, you’ll get €5 off.": "Aquí te explicamos como empezar a ganar puntos; cuando llegues a 500, tendrás 5 € de descuento.",
            "Create a Loyalty Rewards account": "Crear una cuenta de Recompensas de fidelidad",
            "For every €1 you spend, you earn": "Por cada euro que gastes, ganas",
            "Refer your friends": "Tráete a tus amigos",
            "Follow us on Facebook": "Síguenos en Facebook",
            "Follow us on Instagram": "Síguenos en Instagram",
            "Signing up to our mailing list": "Apúntate a nuestra lista de distribución",
            "Leaving a review": "Deja una opinión",
            "Double point promotions": "Promociones de puntos dobles",
            "pts": "puntos"
        };
    } else if (window.location.pathname.includes('/it/')) {
        translations = {
            "Earn Extra Points": "Guadagna punti extra",
            "Here’s how you can start earning points, once you reach 500 points, you’ll get €5 off.": "Ecco come iniziare a guadagnare punti: una volta raggiunti i 500 punti, riceverai uno sconto di 5 €.",
            "Create a Loyalty Rewards account": "Crea un account fedeltà",
            "For every €1 you spend, you earn": "Per ogni euro speso, guadagni",
            "Refer your friends": "Invita i tuoi amici",
            "Follow us on Facebook": "Seguici su Facebook",
            "Follow us on Instagram": "Seguici su Instagram",
            "Signing up to our mailing list": "Iscriviti alla nostra newsletter",
            "Leaving a review": "Lascia una recensione",
            "Double point promotions": "Promozioni punti doppi",
            "pts": "punti"
        };
    }

    if (translations) {
        const heading = document.querySelector('.custom-table-container h2');
        if (heading) {
            heading.textContent = translations[heading.textContent.trim()] || heading.textContent;
        }

        const paragraph = document.querySelector('.custom-table-container p');
        if (paragraph) {
            paragraph.textContent = translations[paragraph.textContent.trim()] || paragraph.textContent;
        }

        const tableCells = document.querySelectorAll('.custom-table td');
        tableCells.forEach((cell) => {
            const originalText = cell.textContent.trim();
            if (translations[originalText]) {
                cell.textContent = translations[originalText];
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const path = window.location.pathname;

    if (
        path.includes('/fr/') || path.endsWith('/fr') ||
        path.includes('/it/') || path.endsWith('/it') ||
        path.includes('/es/') || path.endsWith('/es')
    ) {
        const intervalId = setInterval(() => {
            const callToActionElement = document.querySelector('.blp-call-to-action__signed-out');

            if (callToActionElement && callToActionElement.textContent.trim() === "Sign up and earn Points") {
                if (path.includes('/it/') || path.endsWith('/it')) {
                    callToActionElement.textContent = "Iscriviti per guadagnare punti"; // Italian
                } else if (path.includes('/fr/') || path.endsWith('/fr')) {
                    callToActionElement.textContent = "S'inscrire pour gagner des points"; // French
                } else if (path.includes('/es/') || path.endsWith('/es')) {
                    callToActionElement.textContent = "Regístrate y gana puntos"; // Spanish
                }
                clearInterval(intervalId);
            }
        }, 100);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    let lang = null;
    let translations = null;

    if (window.location.pathname.includes('/fr/')) {
        lang = 'fr';
        translations = {
            "Subscribe & Save": "S'abonner & Économiser",
            "Buy & Go!": "Acheter & Partir !",
            "Subscribe": "S'abonner",
            "UP To": "Jusqu'à ",
            "5%": " 5%",
            "Delivery frequency": "Fréquence de livraison",
            "Every 30 days": "Tous les 30 jours",
            "Save 5%": "Économisez 5 %",
            "Subscription details": "Détails de l'abonnement",
            "You will be billed every 30 days. You can pause, skip or cancel your subscription anytime.":
                "Vous serez facturé tous les 30 jours. Vous pouvez suspendre, sauter ou annuler votre abonnement à tout moment."
        };
    } else if (window.location.pathname.includes('/es/')) {
        lang = 'es';
        translations = {
            "Subscribe & Save": "Suscríbete y ahorra",
            "Buy & Go!": "¡Compra y listo!",
            "Subscribe": "Suscribirse",
            "UP To": "Hasta ",
            "5%": " 5%",
            "Delivery frequency": "Frecuencia de entrega",
            "Every 30 days": "Cada 30 días",
            "Save 5%": "Ahorra 5%",
            "Subscription details": "Detalles de la suscripción",
            "You will be billed every 30 days. You can pause, skip or cancel your subscription anytime.":
                "Se te cobrará cada 30 días. Puedes pausar, saltar o cancelar tu suscripción en cualquier momento."
        };
    } else if (window.location.pathname.includes('/it/')) {
        lang = 'it';
        translations = {
            "Subscribe & Save": "Abbonati e risparmia",
            "Buy & Go!": "Acquista e vai!",
            "Subscribe": "Abbonati",
            "UP To": "Fino a ",
            "5%": " 5%",
            "Delivery frequency": "Frequenza di consegna",
            "Every 30 days": "Ogni 30 giorni",
            "Save 5%": "Risparmia 5%",
            "Subscription details": "Dettagli dell'abbonamento",
            "You will be billed every 30 days. You can pause, skip or cancel your subscription anytime.":
                "Ti verrà addebitato ogni 30 giorni. Puoi sospendere, saltare o annullare l'abbonamento in qualsiasi momento."
        };
    }

    if (!translations) return;

    const intervalId = setInterval(() => {
        const elements = document.querySelectorAll(
            '.subify-root span, .subify-root h6, .subify-root .subify-selling-plan-label, .subify-root .subify-main-selling-plan-container .desktop-description'
        );

        if (elements.length > 0) {
            elements.forEach((element) => {
                element.childNodes.forEach((child) => {
                    if (child.nodeType === Node.TEXT_NODE) {
                        const originalText = child.textContent.trim();
                        if (translations[originalText]) {
                            child.textContent = translations[originalText];
                        }
                    }
                });

                const originalText = element.textContent.trim();
                if (translations[originalText]) {
                    element.textContent = translations[originalText];
                }
            });

            clearInterval(intervalId);
        }
    }, 100);
});


document.addEventListener("DOMContentLoaded", function () {
    function updateCartLinks() {
        document.querySelectorAll(".cart-link").forEach(link => {
            let href = link.getAttribute("href");
            const htmlLang = document.documentElement.lang;
            if (href && href.includes("return_to=")) {
                let updatedHref;

                if (htmlLang === "fr") {
                    updatedHref = href.replace(/(return_to=)(https?:\/\/[^\/]+)?(\/[^?]*)?/, "$1/fr/cart");
                } else if (htmlLang === "es") {
                    updatedHref = href.replace(/(return_to=)(https?:\/\/[^\/]+)?(\/[^?]*)?/, "$1/es/cart");
                } else if (htmlLang === "it") {
                    updatedHref = href.replace(/(return_to=)(https?:\/\/[^\/]+)?(\/[^?]*)?/, "$1/it/cart");
                } else {
                    updatedHref = href.replace(/(return_to=)(https?:\/\/[^\/]+)?(\/[^?]*)?/, "$1/cart");
                }

                link.setAttribute("href", updatedHref);
            }
        });
    }

    updateCartLinks();

    const cartLink = document.querySelector(".logo-area__right__inner .cart-link");
    if (cartLink) {
        cartLink.addEventListener("click", function () {
            setTimeout(updateCartLinks, 500);
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/es/') || window.location.pathname.endsWith('/es')) {

        const translations = {
            "read more": "Leer más",
            "read less": "Leer menos"
        };

        const elementsToTranslate = document.querySelectorAll('a.read-more, a.read-less');

        elementsToTranslate.forEach(el => {
            const originalText = el.textContent.trim().toLowerCase();
            
            if (translations[originalText]) {
                el.textContent = translations[originalText];
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/it/') || window.location.pathname.endsWith('/it')) {

        const translations = {
            "read less": "Leggi di meno"
        };

        const elementsToTranslate = document.querySelectorAll('a.read-more, a.read-less');

        elementsToTranslate.forEach(el => {
            const originalText = el.textContent.trim().toLowerCase();
            
            if (translations[originalText]) {
                el.textContent = translations[originalText];
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/account/')) {

        const translations = {
            "Orders": "Ordini"
        };

        // Select only the Orders link in the header
        const menuLinks = document.querySelectorAll('header a');

        menuLinks.forEach(el => {
            const originalText = el.textContent.trim();
            if (translations[originalText]) {
                el.textContent = translations[originalText];
            }
        });
    }
});



document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/it/") || path.endsWith("/it")) {
    addNewsletterAfter();
  }

  function addNewsletterAfter() {
    const style = document.createElement("style");
    style.innerHTML = `
    .section-newsletter .container::after {
        content: 'Iscrivendoti alla newsletter accetti la nostra informativa sulla privacy.';
        font-size: 10px;
        height: 100%;
        padding-top: 10px;
        position: relative;
        display: block;
    }
    .cart-info-block,
    .template-cart .section-rich-text {
        display: none;
    }
    .pageheader .logo__image {
        width: 220px !important;
    }
    .shopify-section:has(.klaviyo-form-XYZnn7) {
        display: block !important;
    }
    `;
    document.head.appendChild(style);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/fr/") || path.endsWith("/fr")) {
    addNewsletterAfter3();
  }

  function addNewsletterAfter3() {
    const style = document.createElement("style");
    style.innerHTML = `
    .shopify-section:has(.klaviyo-form-TrTxj8) {
        display: block !important;
    }
    `;
    document.head.appendChild(style);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (!(path.includes("/it/") || path.endsWith("/it") || path.includes("/es") || path.endsWith("/es") || path.includes("/fr") || path.endsWith("/fr"))) {
    addNewsletterAfter2();
  }

  function addNewsletterAfter2() {
    const style = document.createElement("style");
    style.innerHTML = `
    .shopify-section:has(.klaviyo-form-UZvtiR) {
        display: block !important;
    }
    `;
    document.head.appendChild(style);
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/es/") || path.endsWith("/es")) {
    addNewsletterAfter();
  }

  function addNewsletterAfter() {
    const style = document.createElement("style");
    style.innerHTML = `
    .section-newsletter .container::after {
        content: 'Al suscribirte al boletín, aceptas nuestra política de privacidad.';
        font-size: 10px;
        height: 100%;
        padding-top: 10px;
        position: relative;
        display: block;
    }
    .cart-info-block,
    .template-cart .section-rich-text {
        display: none;
    }
    .pageheader .logo__image {
        width: 220px !important;
    }

    .shopify-section:has(.klaviyo-form-S8TFM4) {
        display: block !important;
    }
    `;
    document.head.appendChild(style);
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const path = window.location.pathname;
    if (path.includes('/es/') || path.endsWith('/es') || path.includes('/it/') || path.endsWith('/it')) {
        const container = document.getElementById('blp-container');
        if (container) {
            container.style.display = 'none';
        }
    }

    const logoImg = document.querySelector('html .logo img');
    if (logoImg) {
        logoImg.style.width = '150px';
        logoImg.style.height = '76px';
        logoImg.style.paddingTop = '25px';
        logoImg.style.objectFit = 'contain';
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/it/") || path.endsWith("/it")) {
    const elements = document.querySelectorAll(".product-info-accordion");
    if (elements.length >= 3) {
      elements[2].style.display = "none";
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/es/") || path.endsWith("/es")) {
    const elements = document.querySelectorAll(".product-info-accordion");
    if (elements.length >= 3) {
      elements[2].style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (path.includes("/fr/") || path.endsWith("/fr")) {
    const socialLinks = document.querySelectorAll(".social__link");

    socialLinks.forEach(link => {
      if (link.getAttribute("href") === "https://www.instagram.com/llrg5_en/") {
        link.setAttribute("href", "https://www.instagram.com/llrg5_fr/");
      }
    });
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   var oldDomain = "g5laboratories.com";
//   var newDomain = "llrg5.com";

//   if (window.location.hostname === oldDomain) {
//     var newUrl = window.location.href.replace(oldDomain, newDomain);
//     window.location.replace(newUrl);
//   }
// });